import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

const create = (planId: number) =>
  reactQueryPost(internalApi.scheduleDowngrades.create(planId), {});

export const scheduleDowngradesApi = {
  create,
};
